export type FilterSubject = {
  value: string;
  text: string;
  checked: boolean;
};

export type FilterInterestAreaSubjects = {
  value: string;
  id: string;
  text: string;
  checked: boolean;
  subjects: FilterSubject[];
};
export type FilterCollapseOption = {
  value: string;
  text: string;
  description: string;
};

export const extractUniqueValues = (data: any[], key: string): FilterCollapseOption[] => {
  const valueMap = new Map<string, FilterCollapseOption>();
  data
    .flatMap((item) => item[key])
    .filter((item) => item.id)
    .forEach((item) => {
      const value = item.slug;
      const text = item.title as string;
      const description = item?.description as string;
      valueMap.set(value, { value, text, description });
    });

  const sortedValues = Array.from(valueMap.values()).sort((a, b) => a.text.localeCompare(b.text));

  return sortedValues || [];
};

export const extractUniqueSubjects = (data: any[], key: string): FilterInterestAreaSubjects[] => {
  const valueMap = new Map<string, FilterInterestAreaSubjects>();
  data
    .flatMap((item) => item[key])
    .filter((item) => item.id)
    .forEach((item) => {
      const value = item.slug;
      const id = item.id;
      const text = item.title as string;
      const checked = false;
      // const subjects = item.subjects.map((subject: any) => {
      //   return {
      //     value: subject.slug,
      //     text: subject.title,
      //     checked: false,
      //   };
      // });
      const subjects = item.subjects
        .map((subject: any) => {
          return {
            value: subject.slug,
            text: subject.title,
            checked: false
          };
        })
        .sort((a: FilterSubject, b: FilterSubject) =>
          a.text.localeCompare(b.text, undefined, { sensitivity: "base" })
        );
      valueMap.set(value, { value, text, subjects, checked, id });
    });

  const sortedValues = Array.from(valueMap.values()).sort((a, b) => a.text.localeCompare(b.text));

  return sortedValues || [];
};
